import { FC } from 'react';

import Stack from '@mui/material/Stack';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Section from 'components/Section';
import FlightsProviderSelect from 'components/FlightsProviderSelect';
import TextField from 'components/TextField';
import TwoColumn from 'components/TwoColumn';
import PercentInput from 'components/PercentInput';
import Checkbox from 'components/Checkbox';

const GeneralSettingsEditFormFlights: FC = () => (
  <Section id="flights" title="Skrydžiai">
    <Stack spacing={4}>
      <TwoColumn
        left={<FlightsProviderSelect name="flightsProvider" label="Tiekėjas" />}
        right={
          <TextField
            fullWidth
            name="keepFlightPriceHistoryDays"
            label="Skrydžių kainų istorijos saugojimo periodas"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">dienos</InputAdornment>
              ),
            }}
          />
        }
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="flightsApiLimit"
            label="Užklausų limitas"
            helperText="0 - nėra limito"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">/min.</InputAdornment>
              ),
            }}
          />
        }
        right={
          <TextField
            fullWidth
            name="updateFlightsPerMinute"
            label="Atnaujinti skrydžių"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">/min.</InputAdornment>
              ),
            }}
          />
        }
      />

      <TwoColumn
        left={
          <TextField
            fullWidth
            name="priceChangeTreshold"
            label="Kainos pokyčio tolerancija"
            component={PercentInput}
          />
        }
        right={
          <TextField
            fullWidth
            name="inactiveUpdaterWarningThreshold"
            label="Įspėti kai skrydis neatsinaujina daugiau nei"
            InputProps={{
              endAdornment: <InputAdornment position="end">val</InputAdornment>,
            }}
          />
        }
      />

      <TwoColumn
        left={
          <FormControlLabel
            label="Skrydžių atnaujinimas"
            control={<Checkbox name="flightsUpdaterEnabled" />}
          />
        }
        right={
          <FormControlLabel
            label="Automatiškai užsakyti skrydžius"
            control={<Checkbox name="flightBookingEnabled" />}
          />
        }
      />
    </Stack>
  </Section>
);

export default GeneralSettingsEditFormFlights;
